import { Pipe, PipeTransform } from '@angular/core';
import {DataService} from '../services/data.service';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'img'
})
export class ImgPipe implements PipeTransform {
  constructor(
    private dataService: DataService
  ) {}

  transform(src: string): Observable<string> {

    if (src.startsWith('assets/')) {
      return of(src);
    }

    return this.dataService.getImage(src).pipe(
      map(result => 'data:image/png;base64,'+result.byteArray)
    );
  }
}
